<template>
  <div class="main">
    <div class="header">
      <h3>关于我们</h3>
      
      <img class="main_img" src="../../assets/images/关于我们/关于我们头部动效/图层14.png" alt=""/>
      <img class="around_img1" src="../../assets/images/关于我们/关于我们头部动效/图层44.png" alt=""/>
      <img class="around_img2" src="../../assets/images/关于我们/关于我们头部动效/组20.png" alt=""/>
      <img class="around_img3" src="../../assets/images/关于我们/关于我们头部动效/图层44拷贝.png" alt=""/>
      <img class="around_img4" src="../../assets/images/关于我们/关于我们头部动效/图层45.png" alt=""/>
      <img class="Pane_1" src="../../assets/images/电子证书/长方块.png" alt="">
      <img class="Pane_2" src="../../assets/images/电子证书/长方块.png" alt="">
      <img class="Pane_3" src="../../assets/images/电子证书/长方块.png" alt="">
      <img class="Pane_4" src="../../assets/images/电子证书/长方块.png" alt="">
    </div>
    <div class="content">
      <div class="top_title"><p>了解掌网</p></div>

      <div class="content_item1">
        <p>温州掌网信息技术有限公司</p>
        <p>数智一体化解决方案服务商</p>
        <p>{{paragraph1}}</p>
        <p>{{paragraph2}}</p>
        <p>{{paragraph3}}</p>
        <div class="bottom_image">
          <div class="bg_big">
            <img class="bt_img" src="../../assets/images/关于我们/组22.png" alt=""/>
          </div>
          <div class="white_card">
            <p>产品理念</p>
            <div class="line"></div>
            <span>“精致的实用主义”</span>
          </div>
        </div>
      </div>

      <div class="content_item2">
        <div class="main_content">
          <div class="top_box">
            <p class="top_title">选择掌网的四大理由</p>
          </div>
          <div class="bottom_box">
            <div :class="[tagIndex === index ? 'tag2' : 'tag']" v-for="(item,index) in content_item2" :key="index" @mouseenter="tagClick(index)">
              <p class="bottom_title">{{item.title}}</p>
              <p class="bottom_content">{{item.content}}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="content_item3">
        <div class="top_title"><p>完整的产品体系</p></div>
        <div class="product_img">
          <!-- 左 -->
          <div v-show="leftShow">
            <img class="img_1" style="width: 44px;height: 44px;" src="../../assets/images/关于我们/一体化未选中/通用服务.png" alt=""/>
            <p class="title_1">通用服务</p>
            <img class="img_2" style="width: 44px;height: 44px;" src="../../assets/images/关于我们/一体化未选中/应用互联.png" alt=""/>
            <p class="title_2">应用互联</p>
            <img class="img_3" style="width: 44px;height: 44px;" src="../../assets/images/关于我们/一体化未选中/数据标准.png" alt=""/>
            <p class="title_3">数据标准</p>
            <img class="img_4" style="width: 44px;height: 44px;" src="../../assets/images/关于我们/一体化未选中/统一管理.png" alt=""/>
            <p class="title_4">统一管理</p>
            <img class="img_5" style="width: 44px;height: 44px;" src="../../assets/images/关于我们/一体化未选中/统一认证.png" alt=""/>
            <p class="title_5">统一认证</p>
          </div>
          
          <div v-show="!leftShow">
            <img class="img_1" style="width: 44px;height: 44px;" src="../../assets/images/关于我们/一体化选中/通用服务.png" alt=""/>
            <p class="title_1 t1">通用服务</p>
            <img class="img_2" style="width: 44px;height: 44px;" src="../../assets/images/关于我们/一体化选中/应用互联.png" alt=""/>
            <p class="title_2 t1">应用互联</p>
            <img class="img_3" style="width: 44px;height: 44px;" src="../../assets/images/关于我们/一体化选中/数据标准.png" alt=""/>
            <p class="title_3 t1">数据标准</p>
            <img class="img_4" style="width: 44px;height: 44px;" src="../../assets/images/关于我们/一体化选中/统一管理.png" alt=""/>
            <p class="title_4 t1">统一管理</p>
            <img class="img_5" style="width: 44px;height: 44px;" src="../../assets/images/关于我们/一体化选中/统一认证.png" alt=""/>
            <p class="title_5 t1">统一认证</p>
          </div>
          
          <!-- 上 -->
          <div v-show="topShow">
            <img class="img_6" style="width: 44px;height: 44px;" src="../../assets/images/关于我们/电子证书 未选中/提高办公效率.png" alt=""/>
            <p class="title_6">提高办公效率</p>
            <img class="img_7" style="width: 44px;height: 44px;" src="../../assets/images/关于我们/电子证书 未选中/减少碳排放.png" alt=""/>
            <p class="title_7">减少碳排放</p>
            <img class="img_8" style="width: 44px;height: 44px;" src="../../assets/images/关于我们/电子证书 未选中/增强单位公信力.png" alt=""/>
            <p class="title_8">增强组织公信力</p>
            <img class="img_9" style="width: 44px;height: 44px;" src="../../assets/images/关于我们/电子证书 未选中/方便群众办事.png" alt=""/>
            <p class="title_9">方便客户</p>
          </div>

          <div v-show="!topShow">
            <img class="img_6" style="width: 44px;height: 44px;" src="../../assets/images/关于我们/电子证书 选中/提高办公效率.png" alt=""/>
            <p class="title_6 t1">提高办公效率</p>
            <img class="img_7" style="width: 44px;height: 44px;" src="../../assets/images/关于我们/电子证书 选中/减少碳排放.png" alt=""/>
            <p class="title_7 t1">减少碳排放</p>
            <img class="img_8" style="width: 44px;height: 44px;" src="../../assets/images/关于我们/电子证书 选中/增强单位公信力.png" alt=""/>
            <p class="title_8 t1">增强组织公信力</p>
            <img class="img_9" style="width: 44px;height: 44px;" src="../../assets/images/关于我们/电子证书 选中/方便群众办事.png" alt=""/>
            <p class="title_9 t1">方便客户</p>
          </div>
          
          <!-- 右 -->
          <div v-show="rightShow">
            <img class="img_10" src="../../assets/images/关于我们/大数据未选中/可视化.png" alt=""/>
            <p class="title_10">可视化操控</p>
            <img class="img_11" src="../../assets/images/关于我们/大数据未选中/海量.png" alt=""/>
            <p class="title_11">海量存储共享</p>
            <img class="img_12" src="../../assets/images/关于我们/大数据未选中/强大.png" alt=""/>
            <p class="title_12">强大搜索引擎</p>
            <img class="img_13" src="../../assets/images/关于我们/大数据未选中/资产化.png" alt=""/>
            <p class="title_13">资产化运维</p>
            <img class="img_14" src="../../assets/images/关于我们/大数据未选中/场景化.png" alt=""/>
            <p class="title_14">场景化应用</p>
          </div>

          <div v-show="!rightShow">
            <img class="img_10" src="../../assets/images/关于我们/大数据选中/可视化.png" alt=""/>
            <p class="title_10 t1">可视化操控</p>
            <img class="img_11" src="../../assets/images/关于我们/大数据选中/海量.png" alt=""/>
            <p class="title_11 t1">海量存储共享</p>
            <img class="img_12" src="../../assets/images/关于我们/大数据选中/强大.png" alt=""/>
            <p class="title_12 t1">强大搜索引擎</p>
            <img class="img_13" src="../../assets/images/关于我们/大数据选中/资产化.png" alt=""/>
            <p class="title_13 t1">资产化运维</p>
            <img class="img_14" src="../../assets/images/关于我们/大数据选中/场景化.png" alt=""/>
            <p class="title_14 t1">场景化应用</p>
          </div>
          
          <!-- 内圈 -->
          <img class="img_15" src="../../assets/images/关于我们/内圈/域贝一体化平台.png" alt=""/>
          <div v-show="leftShow">
            <p class="title_15">域贝一体化平台</p>
          </div>
          <div v-show="!leftShow">
            <p class="title_15 t1">域贝一体化平台</p>
          </div>
          <img class="img_16" src="../../assets/images/关于我们/内圈/电子证书.png" alt=""/>
          <div v-show="topShow">
            <p class="title_16">域贝电子证书</p>
          </div>
          <div v-show="!topShow">
            <p class="title_16 t1">域贝电子证书</p>
          </div>
          <img class="img_17" src="../../assets/images/关于我们/内圈/大数据.png" alt=""/>
          <div v-show="rightShow">
            <p class="title_17">域贝大数据平台</p>
          </div>
          <div v-show="!rightShow">
            <p class="title_17 t1">域贝大数据平台</p>
          </div>

          <p class="title_21_2">科技型中小企业</p>
          <img class="img_22" src="../../assets/images/关于我们/内圈/数十.png" alt=""/>
          <!-- <p class="title_22">数十项发明专利</p> -->
          <img class="img_23" src="../../assets/images/关于我们/内圈/软件.png" alt=""/>
          <p class="title_23">软件著作权</p>
          <!-- <img class="img_24" src="../../assets/images/关于我们/内圈/成熟度.png" alt=""/>
          <p class="title_24">CMMI-3软件能力成熟度</p> -->
          
          <img :class="leftShow ? 'left_arrow' : 'left_arrow1'" style="width: 71px;height: 38px" src="../../assets/images/关于我们/内圈/形状35拷贝.png" alt=""/>
          <img :class="topShow ? 'top_arrow' : 'top_arrow1'" style="width: 71px;height: 38px" src="../../assets/images/关于我们/内圈/形状35拷贝.png" alt=""/>
          <img v-show="rightShow" class="right_arrow" style="width: 71px;height: 38px" src="../../assets/images/关于我们/内圈/形状35拷贝.png" alt=""/>

          <div class="left_area" @mouseenter="showlight(0)" @mouseleave="hidelight(0)"></div>
          <div class="right_area" @mouseenter="showlight(1)" @mouseleave="hidelight(1)"></div>
          <div class="top_area" @mouseenter="showlight(2)" @mouseleave="hidelight(2)"></div>

          <div v-show="!leftShow">
            <img class="left_circle" src="../../assets/images/关于我们/一体化.png" alt=""/>
            <!-- <img class="left_arrow1" style="width: 71px;height: 38px" src="../../assets/images/关于我们/内圈/形状35拷贝.png" alt=""/> -->
          </div>
          <div v-show="!topShow">
            <img class="top_circle" src="../../assets/images/关于我们/电子证书.png" alt=""/>
          </div>
          <div v-show="!rightShow">
            <img class="right_circle" src="../../assets/images/关于我们/大数据.png" alt=""/>
          </div>

        </div>
      </div>

      <div class="content_item4">
        <div class="top_title"><p>合作伙伴</p></div>
        <div class="bottom_box">
          <div class="img_box" v-for="(item,index) in imgList" :key="index">
            <img :src="item" alt="">
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      paragraph1: '温州掌网信息技术有限公司（简称：掌网信息）成立于2013年，公司位于浙江省温州市鹿城区，是一家专业数智一体化解决方案服务商，致力于用“创新+技术”赋能政企单位数字化改革进程。自主研发的域贝大数据平台、域贝一体化平台等软件产品广泛应用于公安、教育、政企等行业数字化建设。',
      paragraph2: ' ',
      paragraph3: '掌网信息坚持“精致的实用主义”的产品理念，“以客户为中心”的服务理念，“以创新为核心”的经营理念，持续不断地为客户创造价值。公司主要创始人拥有二十多年的信息化系统项目管理经验，是温州市科技局信息化项目评审专家、温州市重大科技创新攻关项目评审专家。公司在大数据应用、一体化平台、人工智能建设等多个领域有丰富的项目经验和技术实力，严格遵循信息系统项目管理标准，拥有一支技术全面、服务优良、结构完整的专业软件开发和服务团队，成功服务于众多客户，通过优质的产品和周到的服务，赢得了市场良好的口碑。',
      tagIndex: 0,
      content_item2: [
        {
          title: '项目经验',
          content: '公司在大数据应用、一体化平台建设等多个领域有丰富的项目经验和技术实力'
        },
        {
          title: '遵循标准',
          content: '我们严格遵循信息系统项目管理标准'
        },
        {
          title: '服务团队',
          content: '掌网信息拥有一支技术全面、服务优良、结构完整的专业软件开发和服务团队'
        },
        {
          title: '市场口碑',
          content: '成功服务于众多客户，通过优质的产品和周到的服务，赢得了市场良好的口碑'
        }
      ],
      imgList: [
        require('../../assets/images/关于我们/合作伙伴/阿里云.png'),
        require('../../assets/images/关于我们/合作伙伴/华为云.png'),
        require('../../assets/images/关于我们/合作伙伴/钉钉.png'),
        require('../../assets/images/关于我们/合作伙伴/图层19.png'),

        require('../../assets/images/关于我们/合作伙伴/温州城发.png'),
        require('../../assets/images/关于我们/合作伙伴/深信服.png'),
        require('../../assets/images/关于我们/合作伙伴/中国移动.png'),
        require('../../assets/images/关于我们/合作伙伴/图层24.png'),

        require('../../assets/images/关于我们/合作伙伴/温州市教育局.png'),
        require('../../assets/images/关于我们/合作伙伴/教育考试院.png'),
        require('../../assets/images/关于我们/合作伙伴/温州市教育技术中心.png'),
        require('../../assets/images/关于我们/合作伙伴/瓯海区教育局.png'),

        require('../../assets/images/关于我们/合作伙伴/鹿城区教育局.png'),
        require('../../assets/images/关于我们/合作伙伴/苍南县教育局.png'),
        require('../../assets/images/关于我们/合作伙伴/苍南县教师发展中心.png'),
        require('../../assets/images/关于我们/合作伙伴/组19.png'),

        require('../../assets/images/关于我们/合作伙伴/瑞安市公安局.png'),
        require('../../assets/images/关于我们/合作伙伴/温州市公安局瓯海分局.png'),
        require('../../assets/images/关于我们/合作伙伴/鹿城公安.png'),
        require('../../assets/images/关于我们/合作伙伴/平阳县公安局分局.png'),
      ],
      leftShow: true,
      topShow: true,
      rightShow: true,
    };
  },
  mounted() {
    // const that = this;
    // window.onresize = () => {
    //   return (() => {
    //     window.screenWidth = document.documentElement.clientWidth; //实时宽度
    //     window.screenHeight = document.documentElement.clientHeight; //实时高度
    //     console.log(window.screenWidth);
    //     window.screenWidth <= 750 ? this.isPhone = true : this.isPhone = false;
    //   })();
    // };
  },
  methods: {
    tagClick(index) {
      this.tagIndex = index
    },
    showlight(index) {
      if(index === 0){
        this.leftShow = false
      }
      if(index === 2){
        this.topShow = false
      }
      if(index === 1){
        this.rightShow = false
      }
    },
    hidelight(index) {
      if(index === 0){
        this.leftShow = true
      }
      if(index === 2){
        this.topShow = true
      }
      if(index === 1){
        this.rightShow = true
      }
    }
  },
};
</script>

<style lang="less" scoped>
.main {
  /*
  *  头部
  */
  .header {
      height: 670px;
      width: 100%;
      background: url('../../assets/images/电子证书/首页图.png');
    h3 {
      position: absolute;
      // top: 350px;
      line-height: 670px;
      left: 20%;
      font-size: 36px;
      font-weight: 500;
      color: #23405a;
      // font-family: AlibabaPuHuiTi_ 2_ 85_ Bold;
      z-index: 100;
    }
    .main_img {
      position: absolute;
      top: 140px;
      left: 38%;
      z-index: 10;
    }
    .around_img1 {
      position: absolute;
      top: 190px;
      left: 38%;
      z-index: 11;
      animation: rightchange1 4s infinite;
    }
    .around_img2 {
      position: absolute;
      top: 150px;
      left: 68%;
      z-index: 11;
      animation: shink 3.5s infinite;
    }
    .around_img3 {
      position: absolute;
      float: right;
      top: 415px;
      right: 20.8%;
      z-index: 11;
      animation: rightchange2 3.7s infinite;
    }
    .around_img4 {
      position: absolute;
      float: right;
      top: 410px;
      right: 46%;
      z-index: 11;
      animation: shink 4s infinite;
    }
   .Pane_1 {
    position: absolute;
    width: 92px;
    height: 311px;
    top: 290px;
    left: 1%;
    z-index: 1;
    animation: heightchange1 4s infinite;
  }
  .Pane_2 {
    position: absolute;
    width: 92px;
    height: 311px;
    top: 160px;
    left: 21%;
    z-index: 1;
    animation: heightchange 4s infinite;
  }
  .Pane_3 {
    position: absolute;
    width: 92px;
    height: 311px;
    top: 150px;
    left: 35.1%;
    z-index: 1;
    animation: heightchange2 4.5s infinite;
  }
  .Pane_4 {
    position: absolute;
    width: 92px;
    height: 311px;
    top: 90px;
    left: 45%;
    z-index: 1;
    animation: heightchange3 3.8s infinite;
  }
  }
  @keyframes shink {
    0% {
      opacity: 0;
    }
    25% {
      opacity: 0.5;
    }
    50% {
      opacity: 1;
    }
    75% {
      opacity: 0.5;
    }
    100% {
      opacity: 0;
    }
  }
  @keyframes rightchange1 {
    0% {
      top: 190px;
    }
    50% {
      top: 170px;
    }
    100% {
      top: 190px;
    }
  }
  @keyframes rightchange2 {
    0% {
      top: 415px;
    }
    50% {
      top: 445px;
    }
    100% {
      top: 415px;
    }
  }
  @keyframes heightchange {
    0% {
      top: 160px;
      height: 250px;
    }
    50% {
      top: 130px;
      height: 311px;
    }
    100% {
      top: 160px;
      height: 250px;
    }
  }
  @keyframes heightchange1 {
    0% {
      top: 290px;
      height: 250px;
    }
    50% {
      top: 320px;
      height: 311px;
    }
    100% {
      top: 290px;
      height: 250px;
    }
  }
  @keyframes heightchange2 {
    0% {
      top: 200px;
      height: 250px;
    }
    50% {
      top: 170px;
      height: 311px;
    }
    100% {
      top: 200px;
      height: 250px;
    }
  }
  @keyframes heightchange3 {
    0% {
      top: 140px;
      height: 250px;
    }
    50% {
      top: 110px;
      height: 311px;
    }
    100% {
      top: 140px;
      height: 250px;
    }
  }
  .content {
    .top_title {
      width: 100%;
      height: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
      p {
        color: #23405a;
        font-size: 30px;
      }
    }
    /*
    *  第一块
    */
    .content_item1 {
      width: 1120px;
      height: 700px;
      margin: 30px auto;
      // background: pink;
      p:first-child {
        font-size: 22px;
        color: #000;
      }
      p:nth-child(2) {
        font-size: 16px;
        margin-top: 30px;
        margin-bottom: 30px;
        color: #607384;
      }
      p:nth-child(3),p:nth-child(4),p:nth-child(5) {
        font-size: 16px;
        text-indent: 2em;
        line-height: 30px;
        margin-top: 10px;
        color: #475d73;
      }
      .bottom_image {
        width: 1200px;
        height: 340px;
        margin-top: 30px;
        margin-left: -40px;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        // background: url('../../assets/images/关于我们/组22.png');
        .bg_big {
          width: 1200px;
          height: 340px;
          position: absolute;
          z-index: 1;
          overflow: hidden;
          .bt_img {
            position: absolute;
            z-index: 1;
            transition: .8s;
          }
          &:hover {
            .bt_img {
              transform: scale(1.05);
            }
          }
        }
        
        .white_card {
          position: relative;
          width: 720px;
          height: 250px;
          background: rgba(255, 255, 255, .9);
          display: flex;
          justify-content: center;
          flex-direction: column;
          align-items: center;
          z-index: 10;
          .line {
            width: 150px;
            height: 1px;
            margin-top: 30px;
            margin-bottom: 30px;
            background: rgb(223, 223, 223);
          }
          p {
            font-size: 36px;
            color: #0d181e;
            font-style:italic;
          }
          span {
            font-size: 20px;
            color: #000;
            letter-spacing: 3px;
          }
        }
      }
    }
    .content_item2 {
      width: 100%;
      height: 420px;
      margin-top: 80px;
      background: url('../../assets/images/关于我们/组21.png');
      .main_content {
        width: 1100px;
        height: 100%;
        margin: 0 auto;
        .top_box {
          width: 100%;
          height: 154px;
          text-align: center;
          .top_title {
            font-size: 30px;
            color: #23405a;
            letter-spacing: 3px;
          }
        }
        .bottom_box {
          width: 100%;
          height: 266px;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          .tag {
            width: 235px;
            height: 266px;
          }
          .tag2 {
            width: 235px;
            height: 266px;
            background: url('../../assets/images/关于我们/合作伙伴/四大理由选择.png');
            .bottom_title,.bottom_content {
              color: #fff;
            }
          }
          .bottom_title {
            font-size: 20px;
            margin: 45px 33px;
            color: #23405a;
          }
          .bottom_content {
            width: 170px;
            font-size: 14px;
            margin: 0 auto;
            color: #475d73;
            text-align: justify;
            line-height: 25px;
          }
        }
      }
    }
    .content_item3 {
      width: 1100px;
      margin: 0 auto;
      height: 933px;
      // background: pink;
      overflow: hidden;
      .product_img {
        width: 862px;
        height: 713px;
        margin: 80px auto;
        background: url('../../assets/images/关于我们/体系圈.png') no-repeat;
        // background-color: #607384;
        // text-align: center;
        // img {
        //   width: 44px;
        //   height: 44px;
        // }
        font-size: 16px;
        .img_1 {
          position: relative;
          top: 600px;
          left: 20px;
          z-index: 1;
        }
        .title_1 {
          position: relative;
          top: 565px;
          left: -50px;
          color: #000;
        }
        
        .img_2 {
          position: relative;
          top: 420px;
          left: -15px;
          z-index: 1;
        }
        .title_2 {
          position: relative;
          top: 385px;
          left: -85px;
          color: #000;
        }
        .img_3 {
          position: relative;
          top: 240px;
          left: -20px;
          z-index: 1;
        }
        .title_3 {
          position: relative;
          top: 205px;
          left: -90px;
          color: #000;
        }
        .img_4 {
          position: relative;
          top: 60px;
          left: 8px;
          z-index: 1;
        }
        .title_4 {
          position: relative;
          top: 25px;
          left: -65px;
          color: #000;
        }
        .img_5 {
          position: relative;
          top: -110px;
          left: 63px;
          z-index: 1;
        }
        .title_5 {
          position: relative;
          top: -145px;
          left: -10px;
          color: #000;
        }
        .img_6 {
          position: relative;
          top: -295px;
          left: 200px;
          z-index: 1;
        }
        .title_6 {
          position: relative;
          top: -355px;
          left: 110px;
          color: #000;
        }
        .img_7 {
          position: relative;
          top: -408px;
          left: 320px;
          z-index: 1;
        }
        .title_7 {
          position: relative;
          top: -480px;
          left: 300px;
          color: #000;
        }
        .img_8 {
          position: relative;
          top: -473px;
          left: 500px;
          z-index: 1;
        }
        .title_8 {
          position: relative;
          top: -547px;
          left: 470px;
          color: #000;
        }
        .img_9 {
          position: relative;
          top: -490px;
          left: 620px;
          z-index: 1;
        }
        .title_9 {
          position: relative;
          top: -560px;
          left: 650px;
          color: #000;
        }
        .img_10 {
          position: relative;
          top: -438px;
          left: 755px;
          z-index: 1;
        }
        .title_10 {
          position: relative;
          top: -472px;
          left: 805px;
          color: #000;
        }
        .img_11 {
          position: relative;
          top: -400px;
          left: 810px;
          z-index: 1;
        }
        .title_11 {
          position: relative;
          top: -435px;
          left: 860px;
          color: #000;
        }
        .img_11 {
          position: relative;
          top: -400px;
          left: 810px;
          z-index: 1;
        }
        .title_11 {
          position: relative;
          top: -435px;
          left: 860px;
          color: #000;
        }
        .img_12 {
          position: relative;
          top: -350px;
          left: 838px;
          z-index: 1;
        }
        .title_12 {
          position: relative;
          top: -385px;
          left: 890px;
          color: #000;
        }
        .img_13 {
          position: relative;
          top: -303px;
          left: 833px;
          z-index: 1;
        }
        .title_13 {
          position: relative;
          top: -340px;
          left: 885px;
          color: #000;
        }
        .img_14 {
          position: relative;
          top: -253px;
          left: 795px;
          z-index: 1;
        }
        .title_14 {
          position: relative;
          top: -290px;
          left: 845px;
          color: #000;
        }
        .img_15 {
          position: relative;
          top: -520px;
          left: 238px;
          z-index: 1;
        }
        .title_15 {
          position: relative;
          top: -565px;
          left: 130px;
          color: #000;
        }
        .img_16 {
          position: relative;
          top: -770px;
          left: 400px;
          z-index: 1;
        }
        .title_16 {
          position: relative;
          top: -860px;
          left: 385px;
          color: #000;
        }
        .img_17 {
          position: relative;
          top: -692px;
          left: 560px;
          z-index: 1;
        }
        .title_17 {
          position: relative;
          top: -737px;
          left: 620px;
          color: #000;
        }
        .img_18 {
          position: relative;
          top: -845px;
          left: 264px;
          z-index: 1;
        }
        .title_18 {
          position: relative;
          top: -881px;
          left: 152px;
          color: #000;
        }
        .img_19 {
          position: relative;
          top: -970px;
          left: 320px;
          z-index: 1;
        }
        .title_19 {
          position: relative;
          top: -1020px;
          left: 210px;
          color: #000;
        }
        .img_20 {
          position: relative;
          top: -990px;
          left: 543px;
          z-index: 1;
        }
        .title_20 {
          position: relative;
          top: -1025px;
          left: 593px;
          color: #000;
        }
        .img_21 {
          position: relative;
          top: -880px;
          left: 543px;
          z-index: 1;
        }
        .title_21 {
          position: relative;
          top: -926px;
          left: 593px;
          color: #000;
        }
        .title_21_2 {
          position: relative;
          top: -924px;
          left: 593px;
          color: #000;
        }
        .img_22 {
          position: relative;
          top: -905px;
          left: 480px;
          z-index: 1;
        }
        .title_22 {
          position: relative;
          top: -915px;
          left: 523px;
          color: #000;
        }
        .img_23 {
          position: relative;
          top: -970px;
          left: 340px;
          z-index: 1;
        }
        .title_23 {
          position: relative;
          top: -980px;
          left: 260px;
          color: #000;
        }
        .img_24 {
          position: relative;
          top: -1095px;
          left: 270px;
          z-index: 1;
        }
        .title_24 {
          position: relative;
          top: -1130px;
          left: 90px;
          color: #000;
        }
        .t1 {
          color: #3186fd ;
        }
        .left_arrow {
          position: relative;
          top: -1245px;
          left: 40px;
          z-index: 1;
          opacity: 0;
        }
        .left_arrow1 {
          position: relative;
          top: -1245px;
          left: 40px;
          z-index: 1;
          opacity: 0;
        }
        .top_arrow {
          position: relative;
          top: -1600px;
          left: 325px;
          transform: rotate(90deg);
          opacity: 0;
          z-index: 1;
        }
        .top_arrow1 {
          position: relative;
          top: -1600px;
          left: 325px;
          transform: rotate(90deg);
          z-index: 1;
          opacity: 0;
        }
        .right_arrow {
          position: relative;
          top: -1245px;
          left: 610px;
          transform: rotate(180deg);
          opacity: 0;
          z-index: 1;
        }
        .left_area {
          position: relative;
          width: 280px;
          height: 500px;
          top: -1500px;
          left: 0;
          z-index: 10;
          // background: #23405a;
        }
        .right_area {
          position: relative;
          width: 280px;
          height: 500px;
          top: -2000px;
          left: 590px;
          z-index: 10;
          // background: #23405a;
        }
        .top_area {
          position: relative;
          width: 400px;
          height: 320px;
          top: -2700px;
          left: 230px;
          z-index: 20;
          // background: #7c9bb6;
        }
        .left_circle {
          position: relative;
          top: -2964px;
          left: 0px;
          z-index: 0.5;
        }
        .top_circle {
          position: relative;
          top: -3020px;
          left: 47px;
          z-index: 0.5;
        }
        .right_circle {
          position: relative;
          top: -3020px;
          left: 47px;
          z-index: 0.5;
        }
      }
    }
    .content_item4 {
      width: 100%;
      height: 792px;
      background: rgb(240,246,251);
      .bottom_box {
        width: 1200px;
        height: 601px;
        margin: 0 auto;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-content: space-between;
        .img_box {
          width: 285px;
          height: 101px;
          background: #fff;
          border-radius: 5px;
          display: flex;
          justify-content: center;
          align-items: center;
          box-shadow:2px 5px 7px 1px rgba(0, 0, 0, .05);
          transition: .5s;
          &:hover {
            transform: translateY(-5px);
          }
        }
      }
    }
  }
}
@media (max-width: 1300px) { 
  .main {
  /*
  *  头部
  */
    .header {
        height: 670px;
        width: 100%;
        background: url('../../assets/images/电子证书/首页图.png');
      h3 {
        // top: 260px;
        left: 7%;
      }
      .main_img {
        position: absolute;
        top: 140px;
        left: 30%;
        z-index: 10;
      }
      .around_img1 {
        position: absolute;
        top: 190px;
        left: 30%;
        z-index: 11;
        animation: rightchange1 4s infinite;
      }
      .around_img2 {
        position: absolute;
        top: 150px;
        left: 75%;
        z-index: 11;
        animation: shink 3.5s infinite;
      }
      .around_img3 {
        position: absolute;
        float: right;
        top: 415px;
        right: 9%;
        z-index: 11;
        animation: rightchange2 3.7s infinite;
      }
      .around_img4 {
        position: absolute;
        float: right;
        top: 410px;
        right: 48%;
        z-index: 11;
        animation: shink 4s infinite;
      }
    }
  }
}
</style>
